module.exports = __webpack_public_path__ + "img/Revizor-Crossword-Puzzle-3-answers.0c2c3d65.jpg";